<template>
  <el-container
    v-if="visiable"
    style="height: 100%;"
    direction="vertical">
    <layout-header />
    <el-container>
      <layout-sider />
      <layout-main />
    </el-container>
  </el-container>
</template>

<script>
import LayoutHeader from '../components/layout/layout-header.vue'
import LayoutSider from '../components/layout/layout-sider.vue'
import LayoutMain from '../components/layout/layout-main.vue'
// import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: { LayoutHeader, LayoutSider, LayoutMain },
  // computed: {
  //   ...mapState({
  //     userInfo: (state) => state.account.userInfo
  //   })
  // },
  data() {
    return { visiable: false }
  },
  mounted() {
    this.$store.dispatch('account/getportalmenutree', {
      payload: { },
      success: (url, menuList) => {
        this.$store.commit('account/setPermission')
        if (!menuList.includes(this.$route.meta.activePath)) {
          this.$router.replace({ path: url })
        }
        this.visiable = true
      },
      fail: (errMsg) => {
        this.$message.error(errMsg)
      }
    })
  }
}
</script>
<style lang="stylus"></style>
